module.exports = __webpack_public_path__ + "media/application/images/ui/icon-footer-about-d4430a744f32b9383a721b789e26a858.png";